<script setup>
import { Edit16 } from '@carbon/icons-vue';
import { Button } from 'next/polaris/ui/button';
import ComposeConversation from 'dashboard/components-next/NewConversation/ComposeConversation.vue';

// What sits at the top of tier 2, next to the area's title: the new-conversation button in the Inbox (D-G8, Q3),
// the assistant and portal pickers (Task 5). Inside the phone's navigation sheet the button only asks for the
// compose form (`compose`): the sheet is modal, so the form opens from outside it once the sheet has closed.
const props = defineProps({
  area: { type: Object, required: true },
  inSheet: { type: Boolean, default: false },
});

const emit = defineEmits(['compose']);
</script>

<template>
  <!-- `contents`: a stable root that leaves no box in the header's flex row -->
  <div class="contents">
    <template v-if="props.area.name === 'inbox'">
      <Button
        v-if="inSheet"
        variant="ghost"
        size="icon-sm"
        :aria-label="$t('NEW_CONVERSATION.TITLE')"
        @click="emit('compose')"
      >
        <Edit16 aria-hidden="true" />
      </Button>
      <ComposeConversation v-else align="start">
        <template #trigger>
          <Button
            v-tooltip.bottom="$t('NEW_CONVERSATION.TITLE')"
            variant="ghost"
            size="icon-sm"
            :aria-label="$t('NEW_CONVERSATION.TITLE')"
          >
            <Edit16 aria-hidden="true" />
          </Button>
        </template>
      </ComposeConversation>
    </template>
  </div>
</template>
